require('../../Styles/v1/main.less');
require('./modernizr');
require('./common');
require('./page');
require('./contact');
require('./simplemap');
require('./salesadmin');
require('./industry');
require('./youtube');
require('./countdown');
require('./endOfWarranty');
require('./toggleButton');
require('./hubspot');
require('./webshop');
require('./isOnScreen');
require('./nav');

import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import 'lazysizes/plugins/bgset/ls.bgset';

import 'lite-youtube-embed';

import stringFormatFunction from './string';
String.prototype.format = String.prototype.f = stringFormatFunction;

import $ from 'jquery';
window.jQuery = window.$ = $;

// https://stackoverflow.com/questions/60357083/does-not-use-passive-listeners-to-improve-scrolling-performance-lighthouse-repo
window.jQuery.event.special.touchstart = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
    }
};



window.jQuery.event.special.touchmove = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
    }
};

window.jQuery.event.special.wheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("wheel", handle, { passive: true });
    }
};

window.jQuery.event.special.mousewheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("mousewheel", handle, { passive: true });
    }
};

import axios from 'axios';
window.axios = axios;




import { createApp } from 'vue/dist/vue.esm-bundler';
window.createApp = createApp;

